import { useMemo } from 'react'
import {
  useGetHazardIdentification,
  useListHazardRiskReductionSteps,
} from '@/shared/hooks/api/machineryDirectiveCompliance'
import {
  isRiskInCapPending,
  resolveRiskInCapForStep,
  type RiskInCap,
} from './riskOutDimensionCap'

export type UseHazardRiskReductionStepRiskInCapParams = {
  hazardId: string
  complianceId: string
  excludeStepId?: string
}

export type UseHazardRiskReductionStepRiskInCapResult = {
  riskInCap: RiskInCap
  isRiskOutCapPending: boolean
}

export function useHazardRiskReductionStepRiskInCap({
  hazardId,
  complianceId,
  excludeStepId,
}: UseHazardRiskReductionStepRiskInCapParams): UseHazardRiskReductionStepRiskInCapResult {
  const { data: hazardSteps = [], isLoading: isStepsLoading } =
    useListHazardRiskReductionSteps(hazardId)
  const { data: hazard, isLoading: isHazardLoading } =
    useGetHazardIdentification(complianceId, hazardId)

  const riskInCap = useMemo(
    () =>
      resolveRiskInCapForStep({
        hazardRiskIn: {
          injury: hazard?.riskInInjury,
          frequency: hazard?.riskInFrequency,
          avoidance: hazard?.riskInAvoidance,
          likelihood: hazard?.riskInLikelihood,
        },
        hazardSteps,
        excludeStepId,
      }),
    [
      excludeStepId,
      hazard?.riskInAvoidance,
      hazard?.riskInFrequency,
      hazard?.riskInInjury,
      hazard?.riskInLikelihood,
      hazardSteps,
    ]
  )

  const isRiskOutCapPending = isRiskInCapPending({
    hazardSteps,
    excludeStepId,
    isStepsLoading,
    isHazardLoading,
  })

  return { riskInCap, isRiskOutCapPending }
}
